import { parseFullName } from 'parse-full-name'

export type Validator = (value?: string, valueToCompare?: string) => string

const invalidValues = [undefined, null, '']

export const validateRequired: Validator = (value?: string): string =>
  invalidValues.includes(value) ? 'This field is required' : ''

export const validateEmail: Validator = (value?: string): string =>
  invalidValues.includes(value) ||
  value?.search(/^[a-zA-Z0-9.!#$%&’*+=?^_`{|}~-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)
    ? 'Please provide your email in the valid format'
    : ''

export const validateFullName: Validator = (value?: string): string => {
  const errorMsg = 'Please provide your full name'
  if (!value) {
    return errorMsg
  }
  const parsedValue = parseFullName(value, 'all', true)
  return !parsedValue.first || !parsedValue.last ? errorMsg : ''
}

export const validateMinLength = (minLength: number, value?: string): string =>
  value && value.length >= minLength ? '' : `Must be at least ${minLength} characters`

export const validateZip = (value?: string): string => {
  const format = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/)
  return value && format.test(value) ? '' : 'Invalid Zip format'
}
